import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function ApprovalMenu(props) {
  return (
    <Dropdown
      menuKey="approval"
      menu={projectMenus.approval}
      {...props}
    />
  );
}
